export const SubmitInvestmentType = "SubmitInvestmentType";
export const ShowAllInvestmentsType = "ShowAllInvestmentsType";